/**
 * PluginBrowserWrapper Component
 * Wrapper for Plugin Browser modal
 */

import React from 'react';
import { PluginBrowser } from '../plugins';
import { toast } from 'sonner';

export const PluginBrowserWrapper = ({
  isOpen,
  onClose,
  onAddPlugin,
  onAddToTrack,
  targetTrackId,
  trackName,
}) => {
  const handleAddPlugin = (plugin) => {
    if (targetTrackId) {
      onAddToTrack(plugin);
      toast.success(`Added ${plugin.name} to ${trackName || 'track'}`);
    } else {
      onAddPlugin(plugin);
      toast.success(`Added ${plugin.name} to master bus`);
    }
    onClose();
  };

  return (
    <PluginBrowser
      isOpen={isOpen}
      onClose={onClose}
      onAddPlugin={handleAddPlugin}
      targetName={targetTrackId ? (trackName || 'Track') : 'Master Bus'}
    />
  );
};

export default PluginBrowserWrapper;
